module.exports = __webpack_public_path__ + "img/default-header.b2564ad.png";